import React from 'react';
import {Stethoscope}   from "lucide-react"
 import { ClockIcon, HomeModernIcon,  HeartIcon,ChartBarIcon,CpuChipIcon } from '@heroicons/react/24/solid';

const SolutionCard = ({ icon, title, description, bgColorClass, borderColorClass }) => {
    return (
        <div className={`
            bg-white rounded-2xl shadow-lg p-6 flex flex-col items-start space-y-4
            border-2 ${borderColorClass || 'border-transparent'}
            hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1
        `}>
     
            <div className={`
                w-12 h-12 rounded-full flex items-center justify-center text-white text-2xl font-bold
                ${bgColorClass}
            `}>
                {icon}
            </div>
            <h3 className="text-xl font-semibold text-gray-800">{title}</h3>
            <p className="text-gray-600 text-base leading-relaxed">{description}</p>
        </div>
    );
};

const SolutionsSection = () => {

    const solutions = [
        {
            icon: <ClockIcon className="w-6 h-6" />, 
            title: 'Time Management AI',
            description: 'Optimize doctor schedules and patient appointment booking for efficiency, reducing wait times.',
            bgColorClass: 'bg-gradient-to-br from-indigo-500 to-blue-500',
            borderColorClass: 'border-blue-200'
        },
        {
            icon: <HomeModernIcon className="w-6 h-6" />, 
            title: 'Home Treatment Guidance',
            description: 'Personalized plans for regular prescriptions, recovery, and wellness, accessible from home.',
            bgColorClass: 'bg-gradient-to-br from-green-500 to-lime-500',
            borderColorClass: 'border-green-200'
        },
        {
            icon:  <CpuChipIcon className="w-6 h-6" />,
            title: 'AI Diagnosis & Advice',
            description: 'Preliminary condition assessment and AI-powered suggestions for when to see a doctor.',
            bgColorClass: 'bg-gradient-to-br from-pink-500 to-rose-500',
            borderColorClass: 'border-pink-200'
        },
        {
            icon: <Stethoscope  className="w-6 h-6" />, 
            title: 'Facility Management',
            description: 'Efficient allocation of hospital resources, beds, and specialized equipment.',
            bgColorClass: 'bg-gradient-to-br from-purple-500 to-fuchsia-500',
            borderColorClass: 'border-purple-200'
        },
        {
            icon: <ChartBarIcon className="w-6 h-6" />, 
            title: 'Patient Analytics',
            description: 'Data-driven insights into patient health trends and treatment effectiveness.',
            bgColorClass: 'bg-gradient-to-br from-yellow-500 to-orange-500',
            borderColorClass: 'border-yellow-200'
        },
        {
            icon:  <HeartIcon className="w-6 h-6" />, 
            title: 'Wellness Monitoring',
            description: 'Proactive tracking of vital signs and health metrics for early intervention.',
            bgColorClass: 'bg-gradient-to-br from-red-500 to-orange-500',
            borderColorClass: 'border-red-200'
        }
    ];

    return (
        <section className="pt-12 md:pt-16 lg:pt-18 pb-16 md:pb-20 lg:pb-28 bg-white">
            <div className="container mx-auto px-4 md:px-6 max-w-7xl">
                <div className="text-center mb-10 md:mb-14 lg:mb-16">
                    <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-gray-900 leading-tight mb-3 md:mb-4">
                        Our Smart Healthcare Solutions
                    </h2>
                    <p className="text-lg md:text-xl text-gray-600 max-w-2xl mx-auto px-4">
                        Comprehensive tools to revolutionize patient care and hospital operations.
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-7 lg:gap-8">
                    {solutions.map((solution, index) => (
                        <SolutionCard
                            key={index}
                            icon={solution.icon}
                            title={solution.title}
                            description={solution.description}
                            bgColorClass={solution.bgColorClass}
                            borderColorClass={solution.borderColorClass}
                        />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default SolutionsSection;